import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-play",
  templateUrl: "./med-icon-play.component.html",
})
export class MedIconPlayComponent extends SvgMixinComponent {}
